import { showGlobalLoading } from "@/components/globalLoading";
import { useDispatch } from "react-redux";
import useRouter from "./useRouter";
import { GameItem } from "@/pages/Game/type";
import API from "@/api";
import { addGame } from "@/redux/reducers/game";
import { useSessionStorage } from "@/util/Storage";
import createBridge from "@/util/WebViewJavascriptBridge";
import { useMetaMask } from "@onyx-p/metamask-react";

export const useGameNavigation = () => {
	const dispatch = useDispatch();
	const { showLoading, hideLoading } = showGlobalLoading();
	const customNavigate = useRouter().customNavigate;
	const { ethereum } = useMetaMask();

	const goToPlay = async (game: GameItem) => {
		try {
			showLoading();

			const response: any = await API.games.apiGetGameUrl({
				gameId: game.gameId,
				mobile: true,
				category: "game_shows",
			});
			hideLoading();
			if (response?.code === 0) {
				dispatch(addGame(game));

				const { entry, html } = response.content.data;
				if (html) {
					localStorage.setItem("gameHtml", entry);
					if (ethereum?.isGameTalk) {
						createBridge((bridge) => {
							bridge.callHandler("openWindow", {
								url:
									window.location.origin +
									"/#/partnergame?type=1",
							});
						});
					} else {
						customNavigate("/partnergame?type=1");
					}
				} else {
					var uri =
						game.gameId.indexOf("pragmatic_casino") > -1
							? entry
							: encodeURIComponent(entry);
					customNavigate("/partnergame?url=" + uri, {
						state: {
							shouldDecode:
								game.gameId.indexOf("pragmatic_casino") === -1,
							url: uri,
						},
					});
				}
			}
		} catch (error) {
			hideLoading();
			console.error("Error fetching data:", error);
		}
	};

	return { goToPlay };
};
